import { render, staticRenderFns } from "./SkinCreate.vue?vue&type=template&id=c731ec84&"
import script from "./SkinCreate.vue?vue&type=script&lang=js&"
export * from "./SkinCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports